import clsx from "clsx";
import { twMerge } from "tailwind-merge";

export type ButtonSize = "big" | "medium";

export function buttonClassName(
  className: string | undefined,
  darkBackground: boolean,
  disabled: boolean,
  size: ButtonSize,
): string {
  return twMerge(
    clsx(
      `bg-primary font-bold-antialiased cursor-pointer rounded-sm text-center text-white uppercase`,
      "focus:outline-primary focus:outline-offset-4",
      "hover:bg-primary-hover",
      {
        "border border-white": darkBackground,
        "disabled:bg-gray disabled:cursor-not-allowed": disabled,
        "max-w-full px-6 py-3": size === "big",
        "max-w-md p-2 text-sm": size === "medium",
      },
      className,
    ),
  );
}
